var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seamless-scroll-container"},[_c('image-horizontal-scroll'),_c('image-horizontal-scroll',{attrs:{"customClassOption":{step: 1}}}),_c('image-horizontal-scroll',{attrs:{"customClassOption":{step: 1.1}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }